import * as ActionTypes from './types';
import { createAction, PayloadAction } from '@reduxjs/toolkit';

export type Warnings = Array<string> | string[];
export type Errors = Array<string> | string;
export interface messagePayload {
    uuid: string;
    message: Array<string>;
    response: {
        body: {
            warnings?: Warnings | any;
            errors?: Array<string> | string | any;
            data?: any;
        };
    };

    customMessage: string;
    warnings: Warnings;
    errors: Errors;
    isMediationPdfCreated?: boolean;
    data?: any;
}

export const removeMessage = createAction<removeMessageAction>(
    ActionTypes.REMOVE_MESSAGE,
);
export const detectWarnings = createAction<detectWarningsAction>(
    ActionTypes.ADD_WARNING_MESSAGE,
);
export const handleBusinessErrors = createAction<handleBusinessErrorsAction>(
    ActionTypes.HANDLE_BUSINESS_ERRORS,
);
export const handleInternalErrors = createAction<handleInternalErrorsAction>(
    ActionTypes.HANDLE_INTERNAL_ERRORS,
);
export const handleServiceErrors = createAction<handleServiceErrorsAction>(
    ActionTypes.HANDLE_SERVICE_ERRORS,
);
export const hideMessage = createAction<hideMessageAction>(
    ActionTypes.HIDE_MESSAGE,
);
export const displayDownloadFileWarning =
    createAction<displayDownloadFileWarningAction>(
        ActionTypes.DISPLAY_DOWNLOAD_FILE_WARNING,
    );

export interface removeMessageAction {
    type?: typeof ActionTypes.REMOVE_MESSAGE;
    payload?: { uuid: string };
    uuid: string;
}

export interface detectWarningsAction {
    type: typeof ActionTypes.ADD_WARNING_MESSAGE;
    body: messagePayload;
}

export interface handleBusinessErrorsAction {
    customMessage: Errors;
}

export interface handleInternalErrorsAction {
    customMessage: Errors;
}

export interface handleServiceErrorsAction {
    customMessage: Errors;
}

export interface hideMessageAction {
    type?: typeof ActionTypes.HIDE_MESSAGE | any;
    payload?: undefined;
}

export interface displayDownloadFileWarningAction {
    body: {
        warnings: Warnings;
    };
}
